var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.showLoader
        ? _c("component-loader", {
            class: { "progress-bar": _vm.reviewPercentLoader },
            attrs: {
              progress: _vm.reviewPercentLoader || 90,
              unlimitedProgress: _vm.reviewPercentLoader ? false : true,
              activeClose: true,
            },
            on: {
              close: function ($event) {
                _vm.showLoader = false
              },
            },
          })
        : _vm._e(),
      _vm.activeModeration
        ? _c(
            "div",
            {
              staticClass: "section-moderation",
              class: [
                { "section-inbox": _vm.activeInbox() && _vm.showInbox() },
              ],
            },
            [
              _c(
                "div",
                {
                  staticClass: "pages-sidebar",
                  class: { contract: _vm.tabsIsMinimize },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "table-title",
                      on: { click: _vm.toggleExpandTabs },
                    },
                    [_c("p", [_vm._v(_vm._s(_vm.$t("dash.moderation.title")))])]
                  ),
                  _c("div", { staticClass: "show-setting" }, [
                    !_vm.tabsIsMinimize
                      ? _c(
                          "i",
                          {
                            staticClass: "material-icons expand-btn minimize",
                            on: { click: _vm.toggleExpandTabs },
                          },
                          [_vm._v("navigate_before")]
                        )
                      : _vm._e(),
                    _vm.tabsIsMinimize
                      ? _c(
                          "i",
                          {
                            staticClass: "material-icons expand-btn maximize",
                            on: { click: _vm.toggleExpandTabs },
                          },
                          [_vm._v("navigate_next")]
                        )
                      : _vm._e(),
                  ]),
                  _c(
                    "div",
                    { staticClass: "search-page" },
                    [
                      _c("vs-input", {
                        staticClass: "inputx",
                        class: { input: true },
                        attrs: {
                          color: "#B20564",
                          "icon-after": "true",
                          icon: "search",
                          placeholder: _vm.$t(
                            "dash.settings.user.label.page_filter"
                          ),
                        },
                        model: {
                          value: _vm.pageFilter,
                          callback: function ($$v) {
                            _vm.pageFilter = $$v
                          },
                          expression: "pageFilter",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "filter-selected" },
                    [
                      _c(
                        "span",
                        {
                          on: {
                            click: function ($event) {
                              _vm.filterSelected = !_vm.filterSelected
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                !_vm.filterSelected
                                  ? `dash.pages-sidebar.filter-selected${
                                      _vm.selectedPages.length > 1
                                        ? "-multi"
                                        : ""
                                    }`
                                  : "dash.pages-sidebar.filter-all"
                              )
                            )
                          ),
                        ]
                      ),
                      _c(
                        "Tooltip",
                        {
                          attrs: {
                            text: _vm.$t(
                              !_vm.selectAllPages
                                ? `dash.pages-sidebar.cta-select-all`
                                : "dash.pages-sidebar.cta-unselect-all"
                            ),
                            position: "top",
                          },
                        },
                        [
                          !_vm.selectAllPages
                            ? _c("img", {
                                attrs: {
                                  alt: "Select all pages",
                                  src: require("../../../assets/img/select_all_icon.svg"),
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.selectAllPages = !_vm.selectAllPages
                                  },
                                },
                              })
                            : _c("img", {
                                attrs: {
                                  alt: "Unselect pages",
                                  src: require("../../../assets/img/unselect_icon.svg"),
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.selectAllPages = !_vm.selectAllPages
                                  },
                                },
                              }),
                          _vm._v("\n             \n          "),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm.groups && _vm.pagesActive
                    ? _c(
                        "ul",
                        [
                          _vm._l(_vm.groups, function (group) {
                            return _c(
                              "li",
                              {
                                key: group.id,
                                staticClass: "group",
                                class: [
                                  {
                                    show: group.show,
                                    hide:
                                      !_vm.checkPagesInGroup(group) ||
                                      _vm.checkGroupFilter(group),
                                  },
                                ],
                              },
                              [
                                _c("div", { staticClass: "group-wrapper" }, [
                                  !group.show
                                    ? _c("img", {
                                        staticClass: "show-group",
                                        attrs: {
                                          alt: "show group",
                                          src: require("../../../assets/img/icon-show-group.svg"),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleShowGroup(group)
                                          },
                                        },
                                      })
                                    : _c("img", {
                                        staticClass: "hide-group",
                                        attrs: {
                                          alt: "hide group",
                                          src: require("../../../assets/img/icon-hide-group.svg"),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleShowGroup(group)
                                          },
                                        },
                                      }),
                                  _c(
                                    "div",
                                    { staticClass: "group-content" },
                                    [
                                      _c(
                                        "Tooltip",
                                        {
                                          attrs: {
                                            text: group.name,
                                            position: "top",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "group-name messagedefilant",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  attrs: {
                                                    "data-text": group.name,
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(_vm._s(group.name)),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(
                                            "\n                   \n                "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "checkbox" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.selectedGroups,
                                          expression: "selectedGroups",
                                        },
                                      ],
                                      attrs: {
                                        type: "checkbox",
                                        id: `groups-${group.id}`,
                                        name: "groups[]",
                                      },
                                      domProps: {
                                        value: group.id,
                                        checked: Array.isArray(
                                          _vm.selectedGroups
                                        )
                                          ? _vm._i(
                                              _vm.selectedGroups,
                                              group.id
                                            ) > -1
                                          : _vm.selectedGroups,
                                      },
                                      on: {
                                        change: [
                                          function ($event) {
                                            var $$a = _vm.selectedGroups,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = group.id,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.selectedGroups =
                                                    $$a.concat([$$v]))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.selectedGroups = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.selectedGroups = $$c
                                            }
                                          },
                                          function ($event) {
                                            return _vm.checkGroup(group)
                                          },
                                        ],
                                      },
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "checkmark",
                                        class: [
                                          {
                                            deselect:
                                              _vm.checkAllPagesGroupSelected(
                                                group
                                              ),
                                          },
                                        ],
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            alt: "checkup",
                                            src: require("../../../assets/img/icon-checkup.svg"),
                                          },
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "material-icons" },
                                          [_vm._v("remove")]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                                _c(
                                  "ul",
                                  _vm._l(group.pages, function (item) {
                                    return _c("div", { key: item }, [
                                      _vm.findPage(item)
                                        ? _c(
                                            "li",
                                            {
                                              staticClass: "page",
                                              class: [
                                                {
                                                  disabled:
                                                    !_vm.checkLock(
                                                      _vm.findPage(item).network
                                                    ) ||
                                                    _vm.accessNotActived(
                                                      _vm.findPage(item)
                                                    ),
                                                  hide:
                                                    !_vm.checkPageFilter(
                                                      _vm.findPage(item)
                                                    ) ||
                                                    !_vm.checkSelected(
                                                      _vm.findPage(item)
                                                    ),
                                                },
                                              ],
                                              on: {
                                                click: function ($event) {
                                                  _vm.accessNotActived(
                                                    _vm.findPage(item)
                                                  )
                                                    ? _vm.confirmActiveAccess(
                                                        item
                                                      )
                                                    : null
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "page-wrapper",
                                                  class: {
                                                    disabled:
                                                      !_vm.checkLock(
                                                        _vm.findPage(item)
                                                          .network
                                                      ) ||
                                                      _vm.accessNotActived(
                                                        _vm.findPage(item)
                                                      ),
                                                  },
                                                },
                                                [
                                                  _vm.loadingPages &&
                                                  _vm.loadingPages[item] &&
                                                  _vm.loadingPages[item].loading
                                                    ? _c("i", {
                                                        staticClass:
                                                          "fa-sharp fa-solid fa-spinner-third loading-page",
                                                      })
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "checkbox",
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.selectedPages,
                                                                expression:
                                                                  "selectedPages",
                                                              },
                                                            ],
                                                            class: {
                                                              radio:
                                                                (![
                                                                  "facebook",
                                                                  "instagram",
                                                                  "linkedin",
                                                                ].includes(
                                                                  _vm.findPage(
                                                                    item
                                                                  ).network
                                                                ) &&
                                                                  _vm.activeInbox()) ||
                                                                !_vm.activeInbox(),
                                                            },
                                                            attrs: {
                                                              type: "checkbox",
                                                              id: `pages-${
                                                                _vm.findPage(
                                                                  item
                                                                ).id
                                                              }`,
                                                              name: "pages[]",
                                                              disabled:
                                                                !_vm.checkLock(
                                                                  _vm.findPage(
                                                                    item
                                                                  ).network
                                                                ) ||
                                                                _vm.accessNotActived(
                                                                  _vm.findPage(
                                                                    item
                                                                  )
                                                                ),
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.pagesActive.findIndex(
                                                                  (p) =>
                                                                    p.id ==
                                                                    _vm.findPage(
                                                                      item
                                                                    ).id
                                                                ),
                                                              checked:
                                                                Array.isArray(
                                                                  _vm.selectedPages
                                                                )
                                                                  ? _vm._i(
                                                                      _vm.selectedPages,
                                                                      _vm.pagesActive.findIndex(
                                                                        (p) =>
                                                                          p.id ==
                                                                          _vm.findPage(
                                                                            item
                                                                          ).id
                                                                      )
                                                                    ) > -1
                                                                  : _vm.selectedPages,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                _vm.updateSelected(
                                                                  _vm.pagesActive.findIndex(
                                                                    (p) =>
                                                                      p.id ==
                                                                      _vm.findPage(
                                                                        item
                                                                      ).id
                                                                  )
                                                                )
                                                              },
                                                              change: function (
                                                                $event
                                                              ) {
                                                                var $$a =
                                                                    _vm.selectedPages,
                                                                  $$el =
                                                                    $event.target,
                                                                  $$c =
                                                                    $$el.checked
                                                                      ? true
                                                                      : false
                                                                if (
                                                                  Array.isArray(
                                                                    $$a
                                                                  )
                                                                ) {
                                                                  var $$v =
                                                                      _vm.pagesActive.findIndex(
                                                                        (p) =>
                                                                          p.id ==
                                                                          _vm.findPage(
                                                                            item
                                                                          ).id
                                                                      ),
                                                                    $$i =
                                                                      _vm._i(
                                                                        $$a,
                                                                        $$v
                                                                      )
                                                                  if (
                                                                    $$el.checked
                                                                  ) {
                                                                    $$i < 0 &&
                                                                      (_vm.selectedPages =
                                                                        $$a.concat(
                                                                          [$$v]
                                                                        ))
                                                                  } else {
                                                                    $$i > -1 &&
                                                                      (_vm.selectedPages =
                                                                        $$a
                                                                          .slice(
                                                                            0,
                                                                            $$i
                                                                          )
                                                                          .concat(
                                                                            $$a.slice(
                                                                              $$i +
                                                                                1
                                                                            )
                                                                          ))
                                                                  }
                                                                } else {
                                                                  _vm.selectedPages =
                                                                    $$c
                                                                }
                                                              },
                                                            },
                                                          }),
                                                          _vm._m(0, true),
                                                        ]
                                                      ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "page-content",
                                                    },
                                                    [
                                                      _c(
                                                        "Tooltip",
                                                        {
                                                          attrs: {
                                                            text: _vm.findPage(
                                                              item
                                                            ).name,
                                                            position: "top",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "page-image-avatar",
                                                            {
                                                              attrs: {
                                                                page: _vm.findPage(
                                                                  item
                                                                ),
                                                              },
                                                            }
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "page-name messagedefilant",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  attrs: {
                                                                    "data-text":
                                                                      _vm.findPage(
                                                                        item
                                                                      ).name,
                                                                  },
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.findPage(
                                                                          item
                                                                        ).name
                                                                      )
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            "\n                         \n                      "
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _vm.findPage(item)
                                                        .count_events
                                                        ? _c(
                                                            "Tooltip",
                                                            {
                                                              staticClass:
                                                                "count",
                                                              attrs: {
                                                                text: `${
                                                                  _vm.findPage(
                                                                    item
                                                                  ).count_events
                                                                } ${_vm.$t(
                                                                  `dash.inbox.page-sidebar.count-event${
                                                                    _vm.findPage(
                                                                      item
                                                                    )
                                                                      .count_events >
                                                                    1
                                                                      ? "s"
                                                                      : ""
                                                                  }`
                                                                )}`,
                                                                position: "top",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "count-events",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.findPage(
                                                                        item
                                                                      )
                                                                        .count_events
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                "\n                         \n                      "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ])
                                  }),
                                  0
                                ),
                              ]
                            )
                          }),
                          _vm._l(_vm.pagesActive, function (item, index) {
                            return _c(
                              "li",
                              {
                                key: item.id,
                                staticClass: "page",
                                class: [
                                  {
                                    current: _vm.selectedTab == index,
                                    disabled:
                                      !_vm.checkLock(item.network) ||
                                      _vm.accessNotActived(item),
                                    hide:
                                      !_vm.checkPageFilter(item) ||
                                      _vm.pageInGroup(item) ||
                                      !_vm.checkSelected(item),
                                  },
                                ],
                                on: {
                                  click: function ($event) {
                                    _vm.accessNotActived(item)
                                      ? _vm.confirmActiveAccess(item)
                                      : null
                                  },
                                },
                              },
                              [
                                !_vm.pageInGroup(item)
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "page-wrapper",
                                        class: {
                                          disabled:
                                            !_vm.checkLock(item.network) ||
                                            _vm.accessNotActived(item),
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "page-content" },
                                          [
                                            _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: item.name,
                                                  position: "top",
                                                },
                                              },
                                              [
                                                _c("page-image-avatar", {
                                                  attrs: { page: item },
                                                }),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "page-name messagedefilant",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        attrs: {
                                                          "data-text":
                                                            item.name,
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(item.name)
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                   \n                "
                                                ),
                                              ],
                                              1
                                            ),
                                            item.count_events
                                              ? _c(
                                                  "Tooltip",
                                                  {
                                                    staticClass: "count",
                                                    attrs: {
                                                      text: `${
                                                        item.count_events
                                                      } ${_vm.$t(
                                                        `dash.inbox.page-sidebar.count-event${
                                                          item.count_events > 1
                                                            ? "s"
                                                            : ""
                                                        }`
                                                      )}`,
                                                      position: "top",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "count-events",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.count_events
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      "\n                   \n                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                        _vm.loadingPages &&
                                        _vm.loadingPages[item.id] &&
                                        _vm.loadingPages[item.id].loading
                                          ? _c("i", {
                                              staticClass:
                                                "fa-sharp fa-solid fa-spinner-third loading-page",
                                            })
                                          : _c(
                                              "div",
                                              { staticClass: "checkbox" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.selectedPages,
                                                      expression:
                                                        "selectedPages",
                                                    },
                                                  ],
                                                  class: {
                                                    radio:
                                                      (![
                                                        "facebook",
                                                        "instagram",
                                                        "linkedin",
                                                      ].includes(
                                                        item.network
                                                      ) &&
                                                        _vm.activeInbox()) ||
                                                      !_vm.activeInbox(),
                                                  },
                                                  attrs: {
                                                    type: "checkbox",
                                                    id: `pages-${item.id}`,
                                                    name: "pages[]",
                                                    disabled:
                                                      !_vm.checkLock(
                                                        item.network
                                                      ) ||
                                                      _vm.accessNotActived(
                                                        item
                                                      ),
                                                  },
                                                  domProps: {
                                                    value: index,
                                                    checked: Array.isArray(
                                                      _vm.selectedPages
                                                    )
                                                      ? _vm._i(
                                                          _vm.selectedPages,
                                                          index
                                                        ) > -1
                                                      : _vm.selectedPages,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.updateSelected(
                                                        index
                                                      )
                                                    },
                                                    change: function ($event) {
                                                      var $$a =
                                                          _vm.selectedPages,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = index,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            (_vm.selectedPages =
                                                              $$a.concat([$$v]))
                                                        } else {
                                                          $$i > -1 &&
                                                            (_vm.selectedPages =
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                ))
                                                        }
                                                      } else {
                                                        _vm.selectedPages = $$c
                                                      }
                                                    },
                                                  },
                                                }),
                                                _vm._m(1, true),
                                              ]
                                            ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                ]
              ),
              ((_vm.pinsData.pages &&
                !["linkedin", "instagram"].includes(
                  _vm.pinsData.pages.network
                )) ||
                (_vm.pagesActive &&
                  _vm.pagesActive[_vm.selectedTab] &&
                  _vm.pagesActive[_vm.selectedTab].network == "google")) &&
              !(_vm.activeInbox() && _vm.showInbox())
                ? _c(
                    "div",
                    { staticClass: "filters-wrapper top" },
                    [
                      _vm.pagesActive &&
                      _vm.pagesActive[_vm.selectedTab] &&
                      _vm.pagesActive[_vm.selectedTab].network != "google"
                        ? _c(
                            "vs-button",
                            {
                              class: { select: _vm.choosemoderation },
                              attrs: { color: "#2F1937" },
                              on: {
                                click: function ($event) {
                                  ;(_vm.choosemoderation = true),
                                    (_vm.chooseconversation = false)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t("dash.moderation.moderationbutton")
                                  ) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.pagesActive &&
                      _vm.pagesActive[_vm.selectedTab] &&
                      _vm.pagesActive[_vm.selectedTab].network != "google"
                        ? _c(
                            "vs-button",
                            {
                              class: { select: _vm.chooseconversation },
                              attrs: { color: "#2F1937" },
                              on: {
                                click: function ($event) {
                                  return _vm.findConversations()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t("dash.moderation.conversationbutton")
                                  ) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.pagesActive &&
                      _vm.pagesActive[_vm.selectedTab] &&
                      _vm.pagesActive[_vm.selectedTab].network == "google"
                        ? _c(
                            "vs-button",
                            {
                              staticClass: "w100",
                              class: { select: _vm.chooseReviews },
                              attrs: { color: "#2F1937" },
                              on: {
                                click: function ($event) {
                                  return _vm.getReviews()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t("dash.moderation.reviewsbutton")
                                  ) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.selectedPages && _vm.selectedPages.length
                ? _c(
                    "div",
                    { staticClass: "page-selected" },
                    [
                      _c("page-image-avatar", {
                        attrs: { page: _vm.pagesActive[_vm.selectedPages[0]] },
                      }),
                      _c("p", { staticClass: "page-name" }, [
                        _vm._v(
                          _vm._s(_vm.pagesActive[_vm.selectedPages[0]].name)
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", { staticClass: "tables-wrapper" }, [
                _vm.activeInbox() && _vm.showInbox()
                  ? _c(
                      "div",
                      { staticClass: "partie-inbox inbox" },
                      [
                        _c("component-inbox", {
                          attrs: {
                            page: _vm.pagesActive[_vm.selectedTab],
                            pages: _vm.selectedPages.map(
                              (p) => _vm.pagesActive[p]
                            ),
                            allPages: _vm.selectAllPages,
                          },
                          on: {
                            updateLoadingPages: _vm.updateLoadingPages,
                            updateCountEvents: _vm.updateCountEvents,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm.pagesActive &&
                    _vm.pagesActive[_vm.selectedTab] &&
                    _vm.pagesActive[_vm.selectedTab].network == "google"
                  ? _c(
                      "div",
                      { staticClass: "reviews" },
                      [
                        _vm.reviews
                          ? [
                              _c("div", { staticClass: "average-rating" }, [
                                _vm._v(
                                  _vm._s(_vm.reviews.averageRating.toFixed(1))
                                ),
                              ]),
                              _c("div", { staticClass: "stars-rating" }, [
                                _c("div", {
                                  staticClass: "background",
                                  style: `width:${
                                    (
                                      (_vm.reviews.averageRating / 5) *
                                      100
                                    ).toFixed(0) - 1
                                  }%`,
                                }),
                                _c("img", {
                                  attrs: {
                                    alt: "stars rate",
                                    src: require("../../../assets/img/star_icon.png"),
                                  },
                                }),
                              ]),
                              _c("div", { staticClass: "total-review-count" }, [
                                _vm._v(
                                  _vm._s(_vm.reviews.totalReviewCount) +
                                    " (" +
                                    _vm._s(_vm.$t("dash.moderation.review")) +
                                    ")"
                                ),
                              ]),
                              _c("div", { staticClass: "sort" }, [
                                _c("div", { staticClass: "sort_by" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("dash.moderation.reviews.sort_by")
                                    )
                                  ),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass: "btn",
                                    class: {
                                      active: _vm.sortReviews == "most_recent",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.sortReviewsBy("most_recent")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "dash.moderation.reviews.sort.most_recent"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "btn",
                                    class: {
                                      active: _vm.sortReviews == "best",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.sortReviewsBy("best")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "dash.moderation.reviews.sort.best"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "btn",
                                    class: {
                                      active: _vm.sortReviews == "least_good",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.sortReviewsBy("least_good")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "dash.moderation.reviews.sort.least_good"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "ul",
                                { staticClass: "reviews" },
                                _vm._l(
                                  _vm.reviews.reviews,
                                  function (review, key) {
                                    return _c(
                                      "li",
                                      { key: key },
                                      [
                                        _c("div", { staticClass: "user" }, [
                                          _c("img", {
                                            attrs: {
                                              src: review.reviewer
                                                .profilePhotoUrl,
                                              alt: review.reviewer.displayName,
                                            },
                                          }),
                                          _c("div", { staticClass: "name" }, [
                                            _vm._v(
                                              _vm._s(
                                                review.reviewer.displayName
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _c(
                                          "div",
                                          { staticClass: "stars-rating" },
                                          [
                                            _c("div", {
                                              staticClass: "background",
                                              style: `width:${
                                                (
                                                  (review.starRating / 5) *
                                                  100
                                                ).toFixed(0) - 1
                                              }%`,
                                            }),
                                            _c("img", {
                                              attrs: {
                                                alt: "stars rate",
                                                src: require("../../../assets/img/star_icon.png"),
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "Tooltip",
                                          {
                                            staticClass: "date",
                                            attrs: {
                                              text: _vm.dateFormat(
                                                review.updateTime
                                              ),
                                              position: "top",
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.dateFromNow(
                                                    review.updateTime
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(
                                              "\n                   \n                "
                                            ),
                                          ]
                                        ),
                                        review.comment
                                          ? _c(
                                              "div",
                                              { staticClass: "comment" },
                                              [_vm._v(_vm._s(review.comment))]
                                            )
                                          : _vm._e(),
                                        review.reviewReply
                                          ? _c(
                                              "div",
                                              { staticClass: "reply" },
                                              [
                                                !_vm.replyReview ||
                                                review.reviewId !=
                                                  _vm.replyReview.reviewId
                                                  ? [
                                                      _c(
                                                        "div",
                                                        { staticClass: "name" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "dash.moderation.reviews.reply.name"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "Tooltip",
                                                        {
                                                          staticClass: "date",
                                                          attrs: {
                                                            text: _vm.dateFormat(
                                                              review.reviewReply
                                                                .updateTime
                                                            ),
                                                            position: "top",
                                                          },
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.dateFromNow(
                                                                  review
                                                                    .reviewReply
                                                                    .updateTime
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                          _vm._v(
                                                            "\n                       \n                    "
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "comment",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              review.reviewReply
                                                                .comment
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  : _vm._e(),
                                                !_vm.replyReview ||
                                                review.reviewId !=
                                                  _vm.replyReview.reviewId
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "cta" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "edit",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.openReplyToReview(
                                                                  review,
                                                                  "edit"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "material-icons",
                                                              },
                                                              [_vm._v("edit")]
                                                            ),
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "dash.moderation.reviews.reply.edit"
                                                                  )
                                                                ) +
                                                                "\n                    "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "remove",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.deleteReplyToReview(
                                                                  review
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "material-icons",
                                                              },
                                                              [_vm._v("delete")]
                                                            ),
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "dash.moderation.reviews.reply.remove"
                                                                  )
                                                                ) +
                                                                "\n                    "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "reply-review",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "name",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "dash.moderation.reviews.reply.name"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _c("vs-textarea", {
                                                          attrs: {
                                                            "vs-size": "large",
                                                            color: "#B20564",
                                                            name: "reply",
                                                            placeholder: _vm.$t(
                                                              "dash.moderation.reviews.reply.description_placeholder"
                                                            ),
                                                            counter: 4000,
                                                            "counter-danger":
                                                              _vm.counterDanger,
                                                          },
                                                          on: {
                                                            "update:counterDanger":
                                                              function (
                                                                $event
                                                              ) {
                                                                _vm.counterDanger =
                                                                  $event
                                                              },
                                                            "update:counter-danger":
                                                              function (
                                                                $event
                                                              ) {
                                                                _vm.counterDanger =
                                                                  $event
                                                              },
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.replyContent,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.replyContent =
                                                                $$v
                                                            },
                                                            expression:
                                                              "replyContent",
                                                          },
                                                        }),
                                                        _c(
                                                          "vs-button",
                                                          {
                                                            attrs: {
                                                              color: "#1a73e8",
                                                              disabled:
                                                                _vm.replyContent
                                                                  .length == 0,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.sendReplyToReview(
                                                                  _vm.replyReview
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "dash.moderation.reviews.reply.add"
                                                                  )
                                                                ) +
                                                                "\n                    "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                              ],
                                              2
                                            )
                                          : [
                                              !_vm.replyReview ||
                                              review.reviewId !=
                                                _vm.replyReview.reviewId
                                                ? _c(
                                                    "div",
                                                    { staticClass: "cta" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "add",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.openReplyToReview(
                                                                review,
                                                                "add"
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "material-icons",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "add_circle"
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "dash.moderation.reviews.reply.add"
                                                                )
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "reply-review",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        { staticClass: "name" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "dash.moderation.reviews.reply.name"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c("vs-textarea", {
                                                        attrs: {
                                                          "vs-size": "large",
                                                          color: "#B20564",
                                                          name: "reply",
                                                          placeholder: _vm.$t(
                                                            "dash.moderation.reviews.reply.description_placeholder"
                                                          ),
                                                          counter: 4000,
                                                          "counter-danger":
                                                            _vm.counterDanger,
                                                        },
                                                        on: {
                                                          "update:counterDanger":
                                                            function ($event) {
                                                              _vm.counterDanger =
                                                                $event
                                                            },
                                                          "update:counter-danger":
                                                            function ($event) {
                                                              _vm.counterDanger =
                                                                $event
                                                            },
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.replyContent,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.replyContent =
                                                              $$v
                                                          },
                                                          expression:
                                                            "replyContent",
                                                        },
                                                      }),
                                                      _c(
                                                        "vs-button",
                                                        {
                                                          attrs: {
                                                            color: "#1a73e8",
                                                            disabled:
                                                              _vm.replyContent
                                                                .length == 0,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.sendReplyToReview(
                                                                _vm.replyReview
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "dash.moderation.reviews.reply.add"
                                                                )
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                            ],
                                        _c("span", {
                                          staticClass: "clearBoth",
                                        }),
                                      ],
                                      2
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          : !_vm.showLoader
                          ? _c("div", { staticClass: "no-reviews" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("dash.reviews.no_reviews")) +
                                  "\n          "
                              ),
                            ])
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm.chooseconversation == true
                  ? _c("div", { staticClass: "partie-conversation" }, [
                      _c("div", { staticClass: "tabs-content" }, [
                        _c("div", { staticClass: "conv" }, [
                          _c("div", { staticClass: "header" }, [
                            _c("div", { staticClass: "title" }, [
                              _vm.pagesActive &&
                              _vm.pagesActive[_vm.selectedTab]
                                ? _c("span", { staticClass: "name" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.pagesActive[_vm.selectedTab].name
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _c(
                              "div",
                              { staticClass: "frequency-wrapper" },
                              [
                                _c("vs-button", {
                                  attrs: {
                                    color: "primary",
                                    type: "filled",
                                    icon: "refresh",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.reloadDiscussion()
                                    },
                                  },
                                }),
                                _c(
                                  "Tooltip",
                                  {
                                    attrs: {
                                      text: _vm.$t("dash.frequency.refresh"),
                                      position: "top",
                                    },
                                  },
                                  [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.refresh.frequency,
                                            expression: "refresh.frequency",
                                          },
                                        ],
                                        on: {
                                          change: [
                                            function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.$set(
                                                _vm.refresh,
                                                "frequency",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            },
                                            function ($event) {
                                              return _vm.reloadDiscussion()
                                            },
                                          ],
                                        },
                                      },
                                      _vm._l(
                                        _vm.refresh.allowed,
                                        function (freq, key) {
                                          return _c(
                                            "option",
                                            {
                                              key: key,
                                              style: freq ? "" : "color: gray",
                                              domProps: { value: freq },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  freq
                                                    ? freq + " sec"
                                                    : _vm.$t(
                                                        "dash.posts.no_refresh"
                                                      )
                                                )
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                    _vm._v(
                                      "\n                   \n                "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "content" }, [
                            _c("ul", [
                              _c(
                                "li",
                                [
                                  _c("component-conversations", {
                                    attrs: {
                                      page: _vm.pagesActive[_vm.selectedTab],
                                      conversationsFromModeration:
                                        _vm.conversationsFromModeration,
                                      refreshdicussion: _vm.refreshdicussion,
                                    },
                                    on: { showDiscussion: _vm.showDiscussion },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "discu" }, [
                          _c("div", { staticClass: "header" }),
                          _c(
                            "div",
                            { staticClass: "content" },
                            [
                              _vm.discussion
                                ? _c("component-discussion", {
                                    attrs: {
                                      discussion: _vm.discussion,
                                      discussionuser: _vm.discussionuser,
                                      attachment: _vm.attachment,
                                      page: _vm.pagesActive[_vm.selectedTab],
                                    },
                                    on: {
                                      messageSend: _vm.messageSend,
                                      reactToMessage: _vm.reactToMessage,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ])
                  : _vm.choosemoderation == true
                  ? _c("div", { staticClass: "partie-moderation" }, [
                      _c("div", { staticClass: "tabs-content" }, [
                        _c("div", { staticClass: "feed" }, [
                          _c("div", { staticClass: "header" }, [
                            _c(
                              "div",
                              { staticClass: "title" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("dash.moderation.my-feed")) +
                                    " \n                "
                                ),
                                _vm.pagesActive &&
                                _vm.pagesActive[_vm.selectedTab]
                                  ? _c("span", { staticClass: "name" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.pagesActive[_vm.selectedTab].name
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                                _c(
                                  "Tooltip",
                                  {
                                    staticClass: "total-count-comments",
                                    attrs: {
                                      text: _vm.$t(
                                        "dash.moderation.total_count_comments"
                                      ),
                                      position: "top",
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.totalCountComments)),
                                    ]),
                                    _vm._v(
                                      "\n                   \n                "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "cta" },
                              [
                                _c("vs-button", {
                                  staticClass: "refresh-feed",
                                  attrs: { "vs-type": "flat", icon: "refresh" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.getPosts()
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "content" },
                            [
                              _vm.posts
                                ? _c("component-posts-feed", {
                                    key: `moderation-table-page-${_vm.idReload}`,
                                    attrs: {
                                      gridData: _vm.posts,
                                      name: "posts-feed",
                                      activeBadWordsDetection:
                                        _vm.activeBadWordsDetection,
                                      badWordList: _vm.badWordList,
                                    },
                                    on: {
                                      switchComment: _vm.switchComment,
                                      getPosts: _vm.getPosts,
                                      addPostLike: _vm.addPostLike,
                                      addPin: _vm.addPin,
                                      removePin: _vm.removePin,
                                      paginationPosts: _vm.paginationPosts,
                                      badWordsDetected: _vm.badWordsDetected,
                                      addCountComments: _vm.addCountComments,
                                    },
                                  })
                                : _vm._e(),
                              (_vm.posts.paging && _vm.posts.paging.next) ||
                              (_vm.posts.paging && _vm.posts.paging.links)
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "pagination-posts next-post",
                                    },
                                    [
                                      _c(
                                        "vs-button",
                                        {
                                          staticClass: "page-btn btn-large",
                                          attrs: { "vs-type": "filled" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.paginationPosts("next")
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  "dash.moderation.next-posts"
                                                )
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                        _c("div", { staticClass: "pins" }, [
                          _c("div", { staticClass: "header" }, [
                            _c("div", { staticClass: "title" }, [
                              _vm._v(
                                _vm._s(_vm.$t("dash.moderation.pins")) + "  "
                              ),
                              _vm.pagesActive &&
                              _vm.pagesActive[_vm.selectedTab]
                                ? _c("span", { staticClass: "name" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.pagesActive[_vm.selectedTab].name
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "content" },
                            [
                              _vm.pins && _vm.pinsData
                                ? _c("component-posts-feed", {
                                    key: "moderation-table-page-pins",
                                    attrs: {
                                      gridData: _vm.pinsData,
                                      name: "pins-feed",
                                      pins: true,
                                      badWordList: _vm.badWordList,
                                    },
                                    on: {
                                      getPosts: _vm.getPosts,
                                      addPostLike: _vm.addPostLike,
                                      removePin: _vm.removePin,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                        _c("div", { staticClass: "comments-bad-words" }, [
                          _c("div", { staticClass: "header" }, [
                            _c("div", { staticClass: "title" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("dash.moderation.comments-bad-words")
                                )
                              ),
                            ]),
                            _c("div", { staticClass: "cta" }, [
                              _c(
                                "div",
                                { staticClass: "bad-word-detection" },
                                [
                                  _c("vs-button", {
                                    staticClass: "manage-bad-words",
                                    attrs: {
                                      "vs-type": "flat",
                                      icon: "settings",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.popupBadWords = true
                                      },
                                    },
                                  }),
                                  _c(
                                    "vs-popup",
                                    {
                                      attrs: {
                                        title: _vm.$t(
                                          "dash.moderation.add-remove-bad-words"
                                        ),
                                        active: _vm.popupBadWords,
                                      },
                                      on: {
                                        "update:active": function ($event) {
                                          _vm.popupBadWords = $event
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "vs-chips",
                                        {
                                          staticClass: "bad-words-list",
                                          attrs: {
                                            color: "rgb(145, 32, 159)",
                                            placeholder: _vm.$t(
                                              "dash.moderation.new-bad-word"
                                            ),
                                            "remove-icon": "delete_forever",
                                          },
                                          model: {
                                            value: _vm.badWordList,
                                            callback: function ($$v) {
                                              _vm.badWordList = $$v
                                            },
                                            expression: "badWordList",
                                          },
                                        },
                                        _vm._l(
                                          _vm.badWordList,
                                          function (word) {
                                            return _c(
                                              "vs-chip",
                                              {
                                                key: word,
                                                attrs: { closable: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeChipBadWord(
                                                      word
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(word) +
                                                    "\n                      "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "content" },
                            [
                              _vm.badWords
                                ? _c("component-posts-feed", {
                                    key: "moderation-table-page-pins",
                                    attrs: {
                                      gridData: _vm.badWords,
                                      name: "bad-words-feed",
                                      badWordsFeed: true,
                                      badWordList: _vm.badWordList,
                                    },
                                    on: {
                                      deleteCommentWithBadWord:
                                        _vm.deleteCommentWithBadWord,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "checkmark" }, [
      _c("img", {
        attrs: {
          alt: "checkup",
          src: require("../../../assets/img/icon-checkup.svg"),
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "checkmark" }, [
      _c("img", {
        attrs: {
          alt: "checkup",
          src: require("../../../assets/img/icon-checkup.svg"),
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }